<script setup lang="ts">
import IdentityForm from '@/components/IdentityForm.vue'
import MemberEmailForm from '@/components/MemberEmailForm.vue'
import type { IdentityCheckoutData, ValidatedIdentityResult } from '@/components/donations/checkout.types'

import { useCheckoutIdentity } from '@/composables/useCheckoutIdentity'

export type CheckoutIdentityFieldsExposed = {
  getValidatedIdentity: () => ValidatedIdentityResult
  resolveIdentityData: () => Promise<IdentityCheckoutData>
}

defineProps<{ disabled?: boolean }>()

const {
  identityFormRef,
  memberEmailFormRef,
  showIdentityForm,
  requireEmailForMember,
  getValidatedIdentity,
  resolveIdentityData,
} = useCheckoutIdentity()

defineExpose({ getValidatedIdentity, resolveIdentityData } satisfies CheckoutIdentityFieldsExposed)
</script>

<template>
  <IdentityForm v-if="showIdentityForm" ref="identityFormRef" :disabled="disabled" />
  <MemberEmailForm v-else-if="requireEmailForMember" ref="memberEmailFormRef" :disabled="disabled" />
</template>
